import React from "react";
import { Link } from "react-router-dom";

const ModernFooter = () => {
  return (
    <footer className="modern-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Optimus</h4>
            <p>Streamline your business with modern POS and API solutions.</p>
          </div>

          <div className="footer-section">
            <h5>Product</h5>
            <Link to="/features">Features</Link>
            <Link to="/pricing">Pricing</Link>
            {/* Add link for kodi-africa */}
            <Link to="/kodi-africa">Kodi Africa</Link>
            {/* <Link to="/documentation">Documentation</Link> */}
          </div>

          <div className="footer-section">
            <h5>Company</h5>
            <Link to="/about">About</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/support">Support</Link>
          </div>

          <div className="footer-section">
            <h5>Legal</h5>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Optimus. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default ModernFooter;
